import * as amplitude from "@amplitude/analytics-react-native"
import { useNavigation, useRoute } from "@react-navigation/native"
import { LinearGradient } from "expo-linear-gradient"
import React, { useContext, useEffect, useRef } from "react"
import { Image } from "react-native"
import { View } from "react-native-animatable"
import { ScrollView } from "react-native-gesture-handler"
import { IconButton } from "react-native-paper"
import { connect } from "react-redux"
import FilledButtonM from "../../../common/components/button/FilledButtonM"
import { SpeechBubbleM } from "../../../common/components/speech-bubble/SpeechBubbleM"
import TextM from "../../../common/components/text/TextM"
import { theme } from "../../../common/theme/theme"
import { DimensionsContext } from "../../../common/utils/mobileUtils"
import { apiIdle, apiRequest } from "../../../data/redux/actions/api"
import { ChampionImageM } from "../../../student/champions/ChampionImageM"
import {
    getBulletPointsSeeMoreData,
    getDiagnosticData,
    getPageComment,
} from "../DiagnosticHelpers"

function BulletPointsSeeMoreScreen(props) {
    const dimensions = useContext(DimensionsContext)
    const navigation = useNavigation()
    const route = useRoute()
    const page = Number(route?.params?.pageNumber) || 1
    const scrollViewRef = useRef(null)

    const diagnosisData = getDiagnosticData(props.analysisData)

    const pageData = diagnosisData[page - 1]

    const data = getBulletPointsSeeMoreData(props.analysisData, page)

    useEffect(() => {
        if (scrollViewRef.current) {
            scrollViewRef.current.scrollTo({ x: 0, y: 0, animated: true })
        }
    }, [page])

    const width =
        dimensions.width > 800 ? dimensions.width / 2.2 : dimensions.width - 20

    useEffect(() => {
        amplitude.track(`school_card_report.diagnostic_screen_${page}.see_more`)
    }, [page])

    return (
        <ScrollView
            ref={scrollViewRef}
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
            horizontal={false}
            style={{ flex: 1, width: "100%" }}
            contentContainerStyle={{
                flexGrow: 1,
                alignItems: "center",
            }}
        >
            <LinearGradient
                colors={pageData.colors}
                style={{
                    flex: 1,
                    paddingTop: 20,
                    width: "100%",
                    height: "100%",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        marginBottom: 20,
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        paddingHorizontal: 10,
                    }}
                >
                    <View style={{ width: 50, alignItems: "flex-start" }}>
                        <IconButton
                            size={32}
                            icon="times"
                            containerColor={theme.colors.transparent}
                            iconColor={theme.colors.primary}
                            onPress={() => {
                                amplitude.track(
                                    `times.school_card_report.diagnostic_screen_${page}.see_more.back`
                                )
                                navigation.goBack()
                            }}
                        />
                    </View>

                    <View style={{ flex: 1 }}>
                        <TextM
                            fontSize={32}
                            fontWeight="ExtraBold"
                            color={theme.colors.primary}
                            style={{
                                textAlign: "center",
                            }}
                            wrap
                        >
                            {data.title}
                        </TextM>
                    </View>
                </View>

                {data.title === "Organisation" && (
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width,
                            marginTop: 10,
                            marginBottom: 20,
                        }}
                    >
                        <ChampionImageM
                            name={pageData?.champion}
                            variant={pageData?.championVariant[pageData?.score]}
                            width={80}
                        />

                        <View style={{ flex: 1, marginLeft: 10 }}>
                            <SpeechBubbleM
                                texts={[getPageComment(pageData)]}
                                position="left"
                                hideIcons={true}
                                noAnimation={true}
                                containerStyle={{
                                    flex: 1,
                                }}
                                textStyle={{
                                    fontSize: 16,
                                    fontFamily: "Montserrat-Regular",
                                    color: theme.colors.black,
                                }}
                            />
                        </View>
                    </View>
                )}

                <Image
                    source={data.icon}
                    style={{
                        width: (width * 2) / 5 + 20,
                        height: (width * 2) / 5 + 20,
                        resizeMode: "contain",
                        marginVertical: 20,
                        shadowColor: "#000",
                        shadowOffset: { width: 0, height: 4 },
                        shadowOpacity: 0.2,
                        shadowRadius: 4,
                        elevation: 8,
                    }}
                />

                <View
                    style={{
                        width: "100%",
                        paddingHorizontal: 20,
                        gap: 20,
                        marginTop: "auto",
                        marginBottom: 20,
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <View style={{ flex: 1 }} />

                    <View
                        style={{
                            paddingHorizontal: 20,
                            marginTop: 16,
                            width,
                        }}
                    >
                        {data.bulletPoints.map((point, index) => (
                            <View
                                key={index}
                                style={{
                                    flexDirection: "row",
                                    alignItems: "flex-start",
                                    marginBottom: 12,
                                }}
                            >
                                <TextM
                                    fontSize={16}
                                    fontWeight="Medium"
                                    color={data.color}
                                    wrap
                                >
                                    {data.symbol}
                                </TextM>
                                <TextM
                                    fontSize={16}
                                    fontWeight="Medium"
                                    color={data.color}
                                    wrap
                                >
                                    {point}
                                </TextM>
                            </View>
                        ))}
                    </View>

                    <FilledButtonM
                        onPress={() => navigation.goBack()}
                        label="Retour"
                        trackingId={`school_card_report.diagnostic_screen_${page}.see_more.back`}
                    />
                </View>
            </LinearGradient>
        </ScrollView>
    )
}

const mapStateToProps = (state) => ({
    analysisData: state.data.schoolCardReport?.analysisData || {},
})

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BulletPointsSeeMoreScreen)
